/* eslint-disable no-param-reassign */
import { ReactElement, useCallback, useRef, useState } from 'react';

import { FormHandles } from '@unform/core';
import { IoIosArrowBack } from 'react-icons/io';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

// import { GoBackButton, ConfirmModal } from '~/components';
import { Layout } from '~/components';
import Button2 from '~/components/Button2';
import { useLoading } from '~/hooks/loading';
import { IExerciseRequiredForm } from '~/models/Exercise';
import ExerciseService from '~/services/Exercise';
import handleYupValidationError from '~/utils/handleYupValidation';
import { ExerciseSchema } from '~/utils/schemas/ExerciseSchema';

import EditExerciseForm from '../EditExerciseForm';

import * as S from './styles';

interface EditExerciseParams {
  id: string;
}

function EditExercise(): ReactElement {
  const { setLoading } = useLoading();

  const formRef = useRef<FormHandles>(null);
  const { id: exerciseId } = useParams<EditExerciseParams>();
  const router = useHistory();
  const [confirmDeleteModal, setConfirmDeleteModal] = useState<boolean>(false);
  const handleCancel = useCallback(() => {
    router.goBack();
  }, [router]);

  const handleEditExerciseSubmit = useCallback(
    async (data: IExerciseRequiredForm) => {
      try {
        setLoading(true);

        formRef.current?.setErrors({});

        if (!data.video_url) {
          data.video_url = '';
        }

        if (!data.video_description) {
          data.video_description = '';
        }

        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        await ExerciseSchema.validate(data, {
          abortEarly: false,
        });

        const result = await ExerciseService.editExercise(exerciseId, data);
        if (result.status === 200) {
          toast.success('Exercício editado com sucesso!');
          router.goBack();
        } else {
          toast.error('Ocorreu um problema ao editar o exercício!');
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
        handleYupValidationError(formRef, error);
      }
    },
    [exerciseId, router, setLoading],
  );

  const handleDeleteExercise = async () => {
    try {
      setLoading(true);

      const result = await ExerciseService.deleteExercise(exerciseId);
      if (result.status === 200) {
        toast.success('Exercicio deletado com sucesso!');
        router.goBack();
      } else {
        toast.error('Ocorreu um problema ao deletar o exercicio!');
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error('Ocorreu um problema ao deletar o exercicio!');
    }
  };

  return (
    <>
      <Layout title="Editar Exercício">
        <S.Container>
          <S.Header onClick={() => router.goBack()}>
            <IoIosArrowBack
              color="#FFDF22"
              size={24}
              style={{ cursor: 'pointer' }}
            />
            <S.Title>Editar Exercício</S.Title>
          </S.Header>
          <EditExerciseForm
            formRef={formRef}
            formName="edit-method"
            handleSubmit={handleEditExerciseSubmit}
            exerciseId={exerciseId}
          />
          <S.Footer>
            <Button2
              form="edit-method"
              type="submit"
              textContent="Salvar"
              variant="yellow"
              size="small"
              extraStyles={{
                width: '420px',
              }}
            />
            {/* <Button2
              type="button"
              onClick={() => setConfirmDeleteModal(true)}
              textContent="Excluir"
              variant="red"
              size="small"
              extraStyles={{
                width: '200px',
              }}
            /> */}
          </S.Footer>
        </S.Container>
      </Layout>

      {/* <ConfirmModal
        modalIsVisible={confirmDeleteModal}
        setModalIsVisible={setConfirmDeleteModal}
        handleSubmit={handleDeleteExercise}
        textContent="Tem certeza de que deseja excluir o exercício?"
        title="Deletar exercício"
      /> */}
    </>
  );
}

export default EditExercise;
